export const state = {
  report: {
    id: '',
    logo: '',
    reports: {},
    subReportCurrentPage: '',
    subReportPages: [],
    subtitle: '',
    title: '',
  }
};
